import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import createStore from './store/index.js'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import { Buffer } from 'buffer'
window.Buffer = Buffer

document.title = 'バーコード読み取り機能'

createApp(App).use(createStore).use(router).mount('#app')
